import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Message } from 'semantic-ui-react';
import { ChecklistReportStore } from 'stores/checklist-reports/checklist-report-store';

interface ChecklistMetricsCardsProps extends WithTranslation {
  checklistReportStore?: ChecklistReportStore;
  compact?: boolean;
}

export const METRIC_ORDER = ['Technical Support', 'Technical Training', 'Conversion', 'Relocation'];

export const getMetricColor = (rate: number): string => {
  if (rate >= 80) return '#04c23a';
  if (rate >= 40) return '#ff9f2a';
  return '#ff1f1f';
};

export const formatMetricRate = (rate: number): string => `%${Math.round(rate)}`;

@connect(['checklistReportStore', ChecklistReportStore])
class ChecklistMetricsCards extends Component<ChecklistMetricsCardsProps> {
  render() {
    const {
      t,
      checklistReportStore: {
        state: { metrics = [], result }
      }
    } = this.props;

    const getMetric = (eventType: string): number => {
      const found = metrics.find(m => m.eventType === eventType);
      return found ? found.completionRate : 0;
    };

    return (
      <div>
        {result && !result.isSuccess && (result.messages || []).length > 0 && (
          <Message
            className="error-message__style"
            icon="exclamation circle"
            error
            list={result.messages.map(o => o.body)}
            onDismiss={this.props.checklistReportStore.clearMessages}
          />
        )}
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', margin: this.props.compact ? '0' : '12px 0' }}>
          {METRIC_ORDER.map(eventType => {
            const rate = getMetric(eventType);
            return (
              <div
                key={eventType}
                style={{
                  backgroundColor: getMetricColor(rate),
                  color: '#fff',
                  borderRadius: 12,
                  padding: this.props.compact ? '12px 18px' : '16px 24px',
                  minWidth: this.props.compact ? 138 : 160,
                  textAlign: 'center',
                  fontWeight: 'bold'
                }}
              >
                <div style={{ fontSize: 13, marginBottom: 8 }}>{t(eventType)}</div>
                <div style={{ fontSize: 28 }}>{formatMetricRate(rate)}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default withTranslation()(ChecklistMetricsCards);
